import AccountRecovery from "./AccountRecovery";

export default AccountRecovery;
